<template>
  <div>
    <div class="cont-list">
      <div class="list-item" v-for="(item, index) in dataList" :key="index">
        <div style="padding: 10px">
          <div class="remark u-line-2">{{item.remark}}</div>
            <div class="imgList" >
                 <img
                v-for="(img, index) in item.imgList"
                :key="index"
                :src="img"
                class="img"
                @click="previewImage(item.imgList, index)"
              />
            </div>
           <div class="desc-p" >
               {{item.address||'--'}}
            </div>
            <div class="desc-p" >
             <van-icon name="clock-o" style="margin-right: 2px"></van-icon> {{ item.createTime }}
            </div>
        </div>
        <div class="card-btn" >
          <div  @click="clickView(item)">查看详情</div>
          <div v-if="item.flowAction=='sspbj'" style="border-left: 1px solid #e2e2e2;" @click="clickPj(item)">评价</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
 import { ImagePreview } from 'vant'
export default {
  props: {
    list: {
      type: Array,
      default() {
        return [];
      }
    },
	idNumber: {
	  type: String,
	  default() {
	    return "";
	  }
	},
	typeShow: {//false 不是户主 true 是户主
	  type: Boolean,
	  default() {
	    return false;
	  }
	},
    houseNumber: {
    	type: String,
    	default: ''
    },
  },
  data() {
    return {
      show:false,
      dataList:[]
    };
  },
 created() {
 },
 watch: {
   list: {
   	immediate: true,
   	handler() {
   		this.dataList = this.list;
		},
	},
   },
  methods: {
    clickView(item) {
      this.$store.state.ssbView = item;
      this.$router.push({
        path:'/people/ssb-view',
      })
    },
    clickPj(item){
      this.$router.push({
        path:'/gzfw/pj',
        query:{id:item.id,flowId:item.flowId}
      })
    },
    previewImage(imageList, current) {
       ImagePreview({
        images: imageList,
        startPosition: current,
      })
    },
  }
};
</script>

<style lang="less" scoped>

.cont-list {
  padding: 8px 14px;
   box-sizing:border-box;
}


.list-item {
  background: #fff;
  border-radius: 6px;
  padding-bottom: 0;
  margin-bottom: 10px;
  box-shadow: 0px 1px 8px 0 rgba(0, 0, 0, 0.08);
  position: relative;
  overflow: hidden;

  .remark{
    font-size: 14px;
    color: #1A1A1A;
  }
  .desc-p{
    color: #999999; font-size: 13px; margin-top: 8px; display: flex; align-items: center
  }

  .imgList{
    display: flex; padding-top: 10px; flex-wrap: wrap;

    img{
      width: 90px;
      height: 90px;
      border-radius: 3px;
      margin-right: 10px;
      margin-bottom: 10px;
    }
  }

 
}

.card-btn {
  display: flex;
  align-items: center;
  text-align: center;
  border-top: 1px solid #e2e2e2;
  // margin-top: 20px;

  div {
    flex: 1;
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    &:active {
      background-color: #eeeeee;
    }
  }
}


</style>
